﻿export const projectSettings = {
	phoneNumber: (window.projectSettings && window.projectSettings.phoneNumber) || "",
	emailAddress: (window.projectSettings && window.projectSettings.emailAddress) || "",
	classActionName: (window.projectSettings && window.projectSettings.classActionName) || "",
	gSiteKey: (window.projectSettings && window.projectSettings.gSiteKey) || ""
};

export const referralTypes = [
	{ name: "Advertising" },
	{ name: "Client" },
	{ name: "Online" },
	{ name: "Family/Friend" },
	{ name: "Professional Referral" },
	{ name: "Staff Referral" },
	{ name: "Media" },
	{ name: "Word of Mouth" },
	{ name: "Other" }
];

export const salutationTypes = [
	{ name: "Dr" },
	{ name: "Mr" },
	{ name: "Miss" },
	{ name: "Ms" },
	{ name: "Mrs" },
	{ name: "Other" }
];

export const yesNoOptions = [
	{ label: "Yes", value: "Yes" },
	{ label: "No", value: "No" }
];

export const yesNoWarningOptions = [
	{ label: "Yes", value: "Yes" },
	{ label: "No *", value: "No" }
];

export const yesNoBooleanOptions = [
	{ label: "Yes", value: true },
	{ label: "No *", value: false }
];

export const yesNoUnsureOptions = [
	{ label: "Yes", value: "Yes" },
	{ label: "No", value: "No" },
	{ label: "Unsure", value: "Unsure" }
];

export const acceptedFileUploadList =
	"application/pdf,.csv,image/*,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/docx,application/pdf,text/plain,application/msword,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";

export const currentInvestigations = [
	{ label: "Blamey Barracks (Kapooka)", value: "Blamey Barracks (Kapooka)" },
	{ label: "HMAS Albatross", value: "HMAS Albatross" },
	{ label: "Holsworthy Barracks", value: "Holsworthy Barracks" },
	{ label: "Singleton Military Area", value: "Singleton Military Area" },
	{ label: "Robertson Barracks", value: "Robertson Barracks" },
	{ label: "HMAS Cairns", value: "HMAS Cairns" },
	{ label: "Lavarack Barracks", value: "Lavarack Barracks" },
	{ label: "RAAF Base Amberley", value: "RAAF Base Amberley" },
	{ label: "Wide Bay Training Area", value: "Wide Bay Training Area" },
	{ label: "HMAS Cerberus", value: "HMAS Cerberus" },
	{ label: "RAAF Base East Sale", value: "RAAF Base East Sale" },
	{ label: "RAAF Williams Laverton Base", value: "RAAF Williams Laverton Base" },
	{ label: "Gingin Satellite Airfield", value: "Gingin Satellite Airfield" },
	{ label: "HMAS Stirling", value: "HMAS Stirling" },
	{
		label: "Naval Communication Station Harold E Holt A & B",
		value: "Naval Communication Station Harold E Holt A & B"
	},
	{ label: "RAAF Base Learmonth", value: "RAAF Base Learmonth" },
	{ label: "Jandakot Airport", value: "Jandakot Airport" }
];
